import { render, staticRenderFns } from "./UserEditReport.vue?vue&type=template&id=2c93bae6&scoped=true"
import script from "./UserEditReport.vue?vue&type=script&lang=js"
export * from "./UserEditReport.vue?vue&type=script&lang=js"
import style0 from "./UserEditReport.vue?vue&type=style&index=0&id=2c93bae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93bae6",
  null
  
)

export default component.exports